import React from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import "./css/Carousel.css";
import styled from "styled-components";
import dropDownIcon from "./images/dropdownIcon.svg";
import CarousalItem from "./components/CarousalItem";

class Carousel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      rightArrow: false,
      leftArrow: false,
      currentSlide: 0,
      position: 0
    };
  }

  componentWillReceiveProps(nextProps) {
    if (this.props !== nextProps) {
      this.setState({
        rightArrow: nextProps.numCards < nextProps.cards.length
      });
    }
  }
  slideRight = () => {
    let numberOfClick = this.props.cards.length - this.props.numCards;
    this.setState(curr => ({
      position: curr.position - 10.5,
      currentSlide: curr.currentSlide + 1,
      rightArrow: !(curr.currentSlide + 1 === numberOfClick),
      leftArrow: curr.currentSlide + 1 > 0
    }));
  };
  slideLift = () => {
    let numberOfClick = this.props.cards.length - this.props.numCards;
    this.setState(curr => ({
      position: curr.position + 10.5,
      currentSlide: curr.currentSlide - 1,
      leftArrow: !(curr.currentSlide - 1 === 0),
      rightArrow: !(curr.currentSlide - 1 === numberOfClick)
    }));
  };
  render() {
    return (
      <div className="carousel-container">
        {this.state.leftArrow && (
          <LeftArrow url={dropDownIcon} onClick={this.slideLift} />
        )}
        <CardsContainer maxWidth={this.props.numCards}>
          <InsideCards position={this.state.position}>
            {this.props.cards &&
              this.props.cards.map((element, index) => (
                <CarousalItem
                  element={element}
                  index={index}
                  key={index}
                  username={this.props.match.params.username}
                  currentCollectionId={this.props.currentCollectionId}
                />
              ))}
          </InsideCards>
        </CardsContainer>
        {this.state.rightArrow && (
          <RightArrow url={dropDownIcon} onClick={this.slideRight} />
        )}
      </div>
    );
  }
}
const mapStateToProps = (state, ownProps) => {
  return {
    contentLoading: state.contentLoading,
    pageLoading: state.pageLoading
  };
};
export default withRouter(connect(mapStateToProps)(Carousel));

const LeftArrow = styled.div`
  height: 1.2rem;
  width: 1.2rem;
  background-color: #fff;
  background-image: url(${props => props.url});
  background-repeat: no-repeat;
  background-position: 50% 60%;
  background-size: 50% 50%;
  cursor: pointer;
  padding: 0.5rem;
  border-radius: 100%;
  -webkit-box-sizing: content-box;
  box-sizing: content-box;

  transform: rotate(90deg) translateX(-1.3rem) translateY(0.5rem);

  @media (max-width: 700px) {
    display: none;
  }
`;
const RightArrow = styled.div`
  height: 1.2rem;
  width: 1.2rem;
  background-color: #fff;
  background-image: url(${props => props.url});
  background-repeat: no-repeat;
  background-position: 50% 60%;
  background-size: 50% 50%;
  cursor: pointer;
  padding: 0.5rem;
  border-radius: 100%;
  -webkit-box-sizing: content-box;
  box-sizing: content-box;

  transform: rotate(-90deg) translateX(1.3rem) translateY(1rem);

  @media (max-width: 700px) {
    display: none;
  }
`;

const CardsContainer = styled.div`
  display: flex;
  overflow: hidden;
  max-width: ${props =>
    props.maxWidth
      ? "calc(10.5rem * " + props.maxWidth + ")"
      : "calc(10.5rem * 3)"};
  -webkit-overflow-scrolling: touch;
  -ms-overflow-style: none;

  position: relative;
  justify-content: flex-start;
  @media (max-width: 700px) {
    max-width: 100% !important;
    overflow-x: auto;
  }
`;

const InsideCards = styled.div`
  display: flex;
  transform: translateX(${props => props.position}rem);
  transition: transform 800ms linear;
`;



// WEBPACK FOOTER //
// ./src/Carousel.jsx